import { render } from "./Button-solicitar-orcamento.vue?vue&type=template&id=f0aee19e&scoped=true"
import script from "./Button-solicitar-orcamento.vue?vue&type=script&lang=js"
export * from "./Button-solicitar-orcamento.vue?vue&type=script&lang=js"

import "./Button-solicitar-orcamento.vue?vue&type=style&index=0&id=f0aee19e&scoped=true&lang=css"

import exportComponent from "E:\\amapa-lp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0aee19e"]])

export default __exports__